import { z } from "zod";
import type { IsoDate } from "./dates.js";

/** How an item on the calendar looks, before or after an edit the assistant proposes. */
export interface EditSnapshot {
  title: string;
  emoji: string | null;
  time: string | null;
  durationMinutes: number;
  /** Tasks: the day it happens. */
  date?: IsoDate;
  /** Habits: when it repeats. */
  daysOfWeek?: number[];
  startDate?: IsoDate;
  endDate?: IsoDate | null;
}

/** One change to something already on the calendar. `after` null means remove it. */
export interface CalendarEdit {
  kind: "habit" | "task";
  id: string;
  before: EditSnapshot;
  after: EditSnapshot | null;
}

/** Changes the assistant proposed to existing habits and tasks. Nothing changes until accepted. */
export interface EditProposal {
  summary: string;
  edits: CalendarEdit[];
}

/** Most edits in one proposal: a guard for the server, room for a whole packed plan. */
export const MAX_PROPOSED_EDITS = 1000;

/** Which of the proposed edits to apply, by position. */
export const acceptChatEditsSchema = z.object({
  indexes: z.array(z.number().int().min(0)).min(1, "Elige al menos un cambio").max(MAX_PROPOSED_EDITS),
});
